import React from 'react'
import { Element } from 'react-scroll'
const Thumbnails = () => {
    return (
        <Element name='Thumbnails'>
            <div className='downGradient'>
                <div className="container">
                    <h1 className="text-center text-light py-5 display-4 fw-bold">Thumbnails</h1>
                    <div className="row">
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>

                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>

                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>

                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>
                        <div className="py-2 col-md-4 col-6">
                            <div className="card border-0 text-center" style={{background:"none"}}>
                                <img src="https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60/https://i.ytimg.com/vi/ra0r7bUtSrc/maxresdefault.jpg" alt="" className="card-img-top rounded-4" />
                                <h3 className="text-warning py-2">Top 10 Cars of the world</h3>
                                <h6 className="text-light">Mr Beast</h6>
                                <p className="text-light">6.5M+ Views</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </Element>
    )
}

export default Thumbnails